<template>
  <div>
    <legend style="font-size: 14px;">
      {{ label }}
    </legend>
    <validation-provider
      #default="{ errors }"
      :rules="{required: require_}"
      name="'E-mail para recebimento de boletos e NFs'"
    >
      <b-form-tags
        v-model="value_"
        :input-id="inputId"
        placeholder=""
        separator=" "
        invalid-tag-text=""
        duplicate-tag-text=""
        :tag-validator="validator"
        :add-button-text="'Adicionar'"
        remove-on-delete
        :disabled="disabled"
        tag-class="tags-email-input"
        @tag-state="onTagState"
        @input="mudarParaLowerCase($event)"
      />
      <small
        v-if="invalidTags.length > 0"
        class="text-danger"
      >Insira um email válido</small>
      <small
        v-else-if="duplicateTags.length > 0"
        class="text-danger"
      >E-mail já inserido nesse campo
      </small>
      <small
        v-else-if="value_ && value_.length == 0 && errors.length == 0 && msgErro"
        class="text-danger"
      >O campo E-mail para recebimento de boletos e NFs é obrigatório</small>
      <small
        v-if="invalidTags.length == 0"
        class="text-danger"
      >
        {{ mostrarErro(errors[0]) }}
      </small>
    </validation-provider>
  </div>
</template>

<style lang="scss">
.tags-email-input {
  font-size: 12.6px;
}

.tags-email-input .b-form-tags .b-form-tags-list .b-from-tags-field {
  margin-bottom: 0.25rem;
 }

.tags-email-input .b-form-tags .b-form-tags-list .b-form-tag {
  margin-top: 0.1rem;
  margin-left: -0.5rem;
  margin-bottom: -0.1rem;
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'

export default {
  name: 'Emails',
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    require: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      default: 'tags-emailsBoletos',
    },
    label: {
      type: String,
      default: 'E-mail para recebimento de boletos e NFs',
    },
    msgErro: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      invalidTags: [],
      duplicateTags: [],
      valueAttr: null,
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    require_: {
      get() {
        return this.require
      },
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    mudarParaLowerCase(value) {
      const emails = []
      value.forEach(each => emails.push(each.toLowerCase()))
      this.valueAttr = emails
      this.enviarParaPai()
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return erro.replace('The', 'O campo').replace('field is required', 'é obrigatório')
      }
      return erro
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
  },
}
</script>
